"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkConfig = exports.isTradeBetter = exports.ONE_HUNDRED_PERCENT = exports.ZERO_PERCENT = exports.getUserFee = exports.calculateFee = exports.orderbookRawToObItem = exports.estimateBaseAmountFromObByQuote = exports.computePairAddress = exports.estimateQuoteAmountFromOB = exports.UNI_INIT_CODE_HASH = void 0;
const decimal_js_1 = require("decimal.js");
const constant_1 = require("../../constant");
const ethers_1 = require("ethers");
const bignumber_js_1 = require("bignumber.js");
const solidity_1 = require("@ethersproject/solidity");
const utils_1 = require("ethers/lib/utils");
const sdk_1 = require("@pancakeswap/sdk");
exports.UNI_INIT_CODE_HASH = '0x60806040526001600c5534801561001557600080fd5b50600046905060405180';
function estimateQuoteAmountFromOB(quantity, isBuy, ob, limitPrice) {
    const _ob = ob[isBuy ? 1 : 0];
    if (!_ob || _ob.length === 0)
        return limitPrice && new bignumber_js_1.default(quantity).times(limitPrice).toNumber() || 0;
    if (limitPrice) {
        if ((isBuy && limitPrice < Number(_ob[0].price)) || (!isBuy && limitPrice > Number(_ob[0].price))) {
            return new bignumber_js_1.default(limitPrice).multipliedBy(quantity).toNumber();
        }
    }
    let filledQuantity = new bignumber_js_1.default(0);
    let cumulativeQuote = new bignumber_js_1.default(0);
    for (const orderData of _ob) {
        filledQuantity = filledQuantity.plus(orderData.size);
        const orderQuote = new bignumber_js_1.default(orderData.size).multipliedBy(orderData.price);
        cumulativeQuote = cumulativeQuote.plus(orderQuote);
        if (filledQuantity.gte(quantity)) {
            cumulativeQuote = cumulativeQuote.minus(filledQuantity.minus(quantity).multipliedBy(orderData.price));
            break;
        }
        if ((limitPrice && isBuy && Number(orderData.price) >= limitPrice) ||
            (!isBuy && Number(orderData.price) <= limitPrice)) {
            break;
        }
    }
    if (limitPrice && filledQuantity.lt(quantity)) {
        cumulativeQuote = cumulativeQuote.plus((quantity - filledQuantity.toNumber()) * limitPrice);
    }
    return cumulativeQuote.toNumber();
}
exports.estimateQuoteAmountFromOB = estimateQuoteAmountFromOB;
const computePairAddress = ({ factoryAddress, tokenA, tokenB }) => {
    const [token0, token1] = Number(tokenA) < Number(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
    console.log("factoryAddress", factoryAddress);
    return (0, utils_1.getCreate2Address)(factoryAddress, (0, solidity_1.keccak256)(['bytes'], [
        (0, solidity_1.pack)(['address', 'address'], [token0, token1])
    ]), exports.UNI_INIT_CODE_HASH);
};
exports.computePairAddress = computePairAddress;
function estimateBaseAmountFromObByQuote(quoteAmount, isBuy, ob) {
    const _ob = ob[isBuy ? 1 : 0];
    let filledQuote = new bignumber_js_1.default(0);
    let accumulateBase = new bignumber_js_1.default(0);
    for (const orderData of _ob) {
        const { price, size } = orderData;
        filledQuote = filledQuote.plus(new bignumber_js_1.default(price).times(size));
        accumulateBase = accumulateBase.plus(size);
        if (filledQuote.isGreaterThan(quoteAmount)) {
            accumulateBase = accumulateBase.minus((filledQuote.minus(quoteAmount)).div(price));
            break;
        }
    }
    return accumulateBase.toNumber();
}
exports.estimateBaseAmountFromObByQuote = estimateBaseAmountFromObByQuote;
function parseObToObItem(item) {
    return {
        price: item[0],
        size: Number(item[1]),
        totalSize: 0
    };
}
function orderbookRawToObItem(obRaw) {
    return [obRaw.bids.map(parseObToObItem), obRaw.asks.map(parseObToObItem)];
}
exports.orderbookRawToObItem = orderbookRawToObItem;
function calculateFee({ quote, base, isBuy }, feeRatio = 0) {
    return {
        base,
        quote: _accumulateFee(quote, feeRatio, isBuy),
    };
}
exports.calculateFee = calculateFee;
function getUserFee(feeTier) {
    return (feeTier && feeTier[0]) || 0;
}
exports.getUserFee = getUserFee;
exports.ZERO_PERCENT = new sdk_1.Percent('0');
exports.ONE_HUNDRED_PERCENT = new sdk_1.Percent('1');
function isTradeBetter(tradeA, tradeB, minimumDelta = exports.ZERO_PERCENT) {
    if (tradeA && !tradeB)
        return false;
    if (tradeB && !tradeA)
        return true;
    if (!tradeA || !tradeB)
        return undefined;
    if (tradeA.tradeType !== tradeB.tradeType ||
        !(0, sdk_1.currencyEquals)(tradeA.inputAmount.currency, tradeB.inputAmount.currency) ||
        !(0, sdk_1.currencyEquals)(tradeA.outputAmount.currency, tradeB.outputAmount.currency)) {
        throw new Error('Trades are not comparable');
    }
    if (minimumDelta.equalTo(exports.ZERO_PERCENT)) {
        return tradeA.executionPrice.lessThan(tradeB.executionPrice);
    }
    return tradeA.executionPrice.raw.multiply(minimumDelta.add(exports.ONE_HUNDRED_PERCENT)).lessThan(tradeB.executionPrice);
}
exports.isTradeBetter = isTradeBetter;
function _accumulateFee(amount, feeRatio, isBuy) {
    if (isNaN(feeRatio))
        feeRatio = 0;
    return new decimal_js_1.default(amount)[isBuy ? 'plus' : 'minus'](new decimal_js_1.default(amount).mul(feeRatio / 100)).toNumber();
}
class NetworkConfig {
    constructor(networkId, customRPC) {
        this.networkId = networkId;
        this.configData = {
            router: constant_1.AMM_ROUTER_ADDRESS[this.networkId],
            factory: constant_1.AMM_FACTORY[this.networkId],
            rpc: customRPC || constant_1.RPC_ENDPOINT[this.networkId],
            ammFee: constant_1.AMM_FEE[this.networkId]
        };
        this.provider = new ethers_1.ethers.providers.JsonRpcProvider(this.getRpc());
    }
    getRouter(exchange) {
        return this.configData.router[exchange];
    }
    getFactory(exchange) {
        return this.configData.factory[exchange];
    }
    getRpc() {
        return this.configData.rpc;
    }
    getProvider() {
        return this.provider;
    }
    getFee(exchange) {
        return this.configData.ammFee[exchange] / 100;
    }
}
exports.NetworkConfig = NetworkConfig;
//# sourceMappingURL=utils.js.map